// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"K6-z"};